import type { ReactNode } from 'react';  // ⭐ type import
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
    children: ReactNode;
}

function PageTransition({ children }: PageTransitionProps) {
    const location = useLocation();  // ⭐ 추가

    return (
        <div
            key={location.pathname}  // ⭐ 경로가 바뀔 때마다 재렌더링
            className="animate-fadeIn"
        >
            {children}
        </div>
    );
}

export default PageTransition;